import { call, put } from "redux-saga/effects";
import {
  getOffsiteListSuccess,
  getOffsiteListError,
  loadMoreSuccessOffsite,
  loadMoreErrorOffsite,
} from "../../slices/offsiteSlice";
import { offsiteGetData } from "../../../apis/offsite";

export function* handleOffsiteGetList(action) {
  try {
    const responseData = yield call(offsiteGetData, {
      ...action.payload,
    });

    if (responseData && responseData.status === 1) {
      yield put(getOffsiteListSuccess({ ...responseData }));
    } else {
      yield put(getOffsiteListError({ ...responseData }));
    }
  } catch (error) {
    yield put(getOffsiteListError({ message: "Something went wrong." }));

    console.log(error);
  }
}

export function* handleLoadMoreOffsite(action) {
  try {
    const responseData = yield call(offsiteGetData, {
      ...action.payload,
    });
    if (responseData && responseData.status === 1) {
      yield put(loadMoreSuccessOffsite({ ...responseData }));
    } else {
      yield put(loadMoreErrorOffsite({ ...responseData }));
    }
  } catch (error) {
    yield put(getOffsiteListError({ message: "Something went wrong." }));

    console.log(error);
  }
}
